import React, {useState} from "react";

export function FormPartMultiSelect (props) {
    let {formPart, saveFunction, lang, errors, hasError, showErrors} = props;
	const [value, setValue] = useState(null);

    return (
        <div  className={'form-group'}>
            <label htmlFor={'input-'+formPart.id}>{formPart.label}</label>
            {formPart.options.map((option) =>{
                return !option.hidden && (
                    <div>
                        <div className="custom-control custom-checkbox mr-md-5 ">
                            <input
                                onChange={ (event) => {
									if (event.target.checked) {
										if (value) {
											value.push(event.target.value);
											setValue([...value])
										} else {
											setValue([event.target.value])
										}
									} else {
										let i = value.indexOf(event.target.value)
										if (i > -1) {
											value.splice(i, 1)
										}
									}

									saveFunction(event, formPart.id, 'multiSelect')
								}}
                                style={{'width': '15px', 'height':'15px'}}
                                className={'custom-control-input'}
                                value={option.id}
								name={'checkbox-' + formPart.id + '-' + option.id}
                                id={'checkbox-' + formPart.id + '-' + option.id} type={'checkbox'}
                            />
                            <label style={{'padding-left':'10px', 'width':'100%'}} className="custom-control-label "  htmlFor={'checkbox-' + formPart.id + '-' + option.id} > {option.label}</label>
                        </div>
                    </div>
                );
            })}
            {
				formPart.required && showErrors && (!value || value.length === 0) ? (<span className="form-error-message">{window.Translator.getSlug('ThisFieldIsRequired', lang)}</span>) : ''
            }
        </div>
    );
}
